import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import { DateComponent } from '../../../components/DateComponent';
import { StatusBadge } from '../../../components/status/StatusBadge';
import clsx from 'clsx';

export enum PartnersDealsDataTableAccessorKeys {
	name = 'name',
	date = 'date',
	activeMerchants = 'activeMerchants',
	contactName = 'contactName',
	phone = 'phone',
	email = 'email',
	status = 'status',
}

export const defaultPartnersDealsColumnSizing: ColumnSizing = {
	[PartnersDealsDataTableAccessorKeys.name]: 100,
	[PartnersDealsDataTableAccessorKeys.date]: 50,
	[PartnersDealsDataTableAccessorKeys.activeMerchants]: 50,
	[PartnersDealsDataTableAccessorKeys.contactName]: 100,
	[PartnersDealsDataTableAccessorKeys.phone]: 100,
	[PartnersDealsDataTableAccessorKeys.email]: 100,
	[PartnersDealsDataTableAccessorKeys.status]: 50,
};

export const defaultPartnersDealsColumns: MRT_ColumnDef<IMockDataProps>[] = [
	{
		accessorKey: PartnersDealsDataTableAccessorKeys.name,
		header: 'Name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="fw-bolder fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: PartnersDealsDataTableAccessorKeys.date,
		header: 'Date',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Date</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<DateComponent value={renderedCellValue} />
			</TableCell>
		)
	},
	{
		accessorKey: PartnersDealsDataTableAccessorKeys.activeMerchants,
		header: 'Active merchants',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Active merchants</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: PartnersDealsDataTableAccessorKeys.contactName,
		header: 'Contact name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Contact name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ?? '-'}
			</TableCell>
		)
	},
	{
		accessorKey: PartnersDealsDataTableAccessorKeys.phone,
		header: 'Contact phone',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Contact phone</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: PartnersDealsDataTableAccessorKeys.email,
		header: 'Contact email',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Contact email</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: PartnersDealsDataTableAccessorKeys.status,
		header: 'Status',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Status</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fs-7 fc-text-overflow ms-2">
					<StatusBadge
						badgeContent={renderedCellValue}
						additionalClasses={clsx(renderedCellValue === 'Active' && 'badge-cancelled' )}
					/>
				</div>
			</TableCell>
		)
	},
];

interface IMockDataProps {
	name: string,
	date: string,
	activeMerchants: number,
	contactName: string,
	phone: string,
	email: string,
	status: string,
	id: string,
}

export const mockData: IMockDataProps[] = [
	{
		name: 'Sticky',
		date: '2023-09-23T18:19:24.700293Z',
		activeMerchants: 33,
		contactName: 'Cure Tester',
		phone: '+1555012345',
		email: 'itzhak.a+flex@grsee.com',
		status: 'Active',
		id: 'be709bee-2fc1-49a5-beb4-6ed75d8fa331'
	},
	{
		name: 'Payway',
		date: '2022-05-22T18:19:24.700293Z',
		activeMerchants: 2,
		contactName: 'Test Partner',
		phone: '+1555012345',
		email: 'itzhak.a+flex@grsee.com',
		status: 'Active',
		id: 'be709bee-2fc1-49a5-beb4-6ed7538fa331'

	},
	{
		name: 'Linkmedia',
		date: '2024-03-24T18:19:24.700293Z',
		activeMerchants: 16,
		contactName: 'Ashu Partner',
		phone: '+1555012345',
		email: 'itzhak.a+flex@grsee.com',
		status: 'Active',
		id: 'be709bee-2fc1-45a5-beb4-6ed75d8fa331'

	},
	{
		name: 'Paypal',
		date: '2022-12-24T18:19:24.700293Z',
		activeMerchants: 156,
		contactName: 'Conal Cunningham',
		phone: '+1555012345',
		email: 'itzhak.a+flex@grsee.com',
		status: 'Active',
		id: 'be709bee-3fc1-49a5-beb4-6ed75d8fa331'
	},
];
